import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sling-config-change-log-table',
  templateUrl: './sling-config-change-log-table.component.html',
  styleUrls: ['./sling-config-change-log-table.component.scss']
})
export class SlingConfigChangeLogTableComponent {

  @Input() logs: any[] = [];
  expandedRows: { [key: string]: boolean } = {};

  constructor(private translate: TranslateService) {}

  toggleRow(log: any) {
    if (this.expandedRows[log.id]) {
      delete this.expandedRows[log.id];
    } else {
      this.expandedRows[log.id] = true;
    }
  }

  formatDate(date: string): string {
    if (!date) return '-';
    const d = new Date(date);
    return d.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatValue(value: any): string {
    if (value === null || value === undefined) {
      return '<em>Nulo</em>';
    }
    if (typeof value === 'boolean') {
      return value ? 'Sim' : 'Não';
    }
    if (Array.isArray(value)) {
      if (this.isDateArray(value)) {
        return this.formatDateArray(value);
      }
      return JSON.stringify(value);
    }
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }
    return String(value);
  }

  private isDateArray(arr: any[]): boolean {
    return Array.isArray(arr) && 
           arr.length >= 3 && 
           arr.length <= 6 &&
           typeof arr[0] === 'number' &&
           typeof arr[1] === 'number' &&
           typeof arr[2] === 'number';
  }

  private formatDateArray(arr: any[]): string {
    if (arr.length < 3) return JSON.stringify(arr);
    
    const year = arr[0];
    const month = arr[1] + 1;
    const day = arr[2];
    const hour = arr.length > 3 ? arr[3] : 0;
    const minute = arr.length > 4 ? arr[4] : 0;
    const second = arr.length > 5 ? arr[5] : 0;
    
    const dateStr = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
    const timeStr = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}${second > 0 ? ':' + String(second).padStart(2, '0') : ''}`;
    
    return `${dateStr} ${timeStr}`;
  }

  getChangeCount(changes: any[]): number {
    return changes ? changes.length : 0;
  }

  translateFieldName(fieldName: string): string {
    const fieldTranslations: { [key: string]: string } = {
      'operationStart': 'Início do período',
      'operationEnd': 'Fim do período',
      'historyBeginDate': 'Data Início de Giro de Motor e Lavação',
      'invoiceBeginDate': 'Data Início das Faturas',
      'hasFuelSupply': 'HAS-FUEL-SUPPLY',
      'hasConsumables': 'HAS-CONSUMABLES',
      'hasAccessories': 'HAS-ACCESSORIES',
      'chargePartialService': 'Cobrar serviço parcial',
      'printReceipt': 'Imprimir recibo e comanda',
      'advertiseApp': 'Divulga APP',
      'sendEmailCopy': 'Enviar cópia por e-mail',
      'showHistoryInvoiceApp': 'Exibir Histórico de fatura',
      'earlyPayment': 'Mensalidade antecipada',
      'manageDeck': 'Tem controle de deck',
      'hasFractionalSupply': 'Tem abastecimento por fração',
      'navigationPlanRequired': 'Plano de navegação obrigatório',
      'navigationPlanRequiredWeb': 'Plano de navegação obrigatório Web',
      'navigationPlanRequiredTotem': 'Plano de navegação obrigatório Totem',
      'showMarinaInfo': 'Exibir informações da marina',
      'queueControl': 'Tem controle de fila',
      'preparationControl': 'Exigir range de preparo',
      'queuePositionControl': 'Exibir posição na fila',
      'slingDownOnPreparation': 'Descer barco na preparação',
      'engineWashHistory': 'ENGINE-WASH-HISTORY',
      'notificationsApp': 'Notificações no App',
      'engineTurnSailor': 'Realizada por marinheiro',
      'boatWashSailor': 'Realizada por marinheiro',
      'sharedVacancy': 'Vaga compartilhada',
      'panelsVacancyDisplay': 'Exibir vagas no painel',
      'slingsNextDay': 'Lingadas do próximo dia',
      'autoScheduleUpdateWash': 'Atualização de agendamento automático',
      'hasWashBoatMaintenance': 'Lavação para barco em manutenção',
      'autoScheduleUpdateEngineTurn': 'Atualização de agendamento automático',
      'hasEngineTurnBoatMaintenance': 'Giro de motor para barco em manutenção',
      'ownFuelSupply': 'Abastecimento próprio',
      'finishOnWater': 'Finalizar na água',
      'showSlingOrigin': 'Exibir origem da lingada',
      'includeTotemNavigation': 'Cliente inclui navegação totem',
      'printFuelSupply': 'Imprimir no abastacimento',
      'toConfirm': 'Lingada à confirmar',
      'measuredFuel': 'Abastecimento por medida',
      'consumablesApp': 'Solicitar consumíveis',
      'showBoatsOnMaintenance': 'Exibir barcos em manutenção',
      'addPhotoBasicCustomerApp': 'Adicionar foto básica App Cliente',
      'addPhotoBasicOperatorApp': 'Adicionar foto básica App Operador',
      'addPhotoBasicTotemApp': 'Adicionar foto básica Totem',
      'sendInvoiceViaWhatsapp': 'Enviar fatura via WhatsApp',
      'requestPendingUpApp': 'Solicitar subida',
      'hasContracts': 'Contratos',
      'hasSailor': 'Possui marinheiro',
      'hasPositionCheckSailor': 'Verificar posição do marinheiro',
      'numberSling': 'Limite de agendamentos',
      'timeBetweenWash': 'Tempo entre lavações (dias)',
      'timeBetweenEngineRotation': 'Tempo entre giro de motor (dias)',
      'amountSkipAvaiablePeriods': 'Delay de tempo nos horários (min)',
      'numberOfRecordsPerPage': 'Número de registros por página',
      'accountId': 'Conta padrão',
      'paymentMethodId': 'Forma de pagamento padrão',
      'radiusOfGyration': 'Raio de giro',
      'radiusOfPrepGyration': 'Raio de preparo',
      'boatWashScheduleDays': 'Dias para agendamento ao subir',
      'engineTurnScheduleDays': 'Dias para agendamento ao subir',
      'cityTax': 'Alíquota municipal ISS (%)',
      'daysDue': 'Dias de vencimento',
      'smsGeneralNotices': 'SMS gerais',
      'accountName': 'Nome da conta',
      'paymentMethodName': 'Nome da forma de pagamento',
      'fuelTankFractions': 'Opções de fração',
      'idPlanoContaInterest': 'Plano de conta para Juros/Multa',
      'marineEngineTurnRun': 'Giro Realizado pelo Marina',
      'marineBoatWash': 'Marina realiza a Lavação',
      'idPlanoContaDiscount': 'Plano de conta para Desconto',
      'useIndex': 'Índice de reajuste',
      'indexUsed': 'Informe o índice',
      'timezone': 'Fuso horário',
      'costCenterInStock': 'Centro de custo no estoque',
      'competencyJuros': 'Data de competência para Juros/Multa',
      'competencyDiscount': 'Data de competência para Desconto',
      'anticipation': 'Habilitar Antecipação de títulos',
      'anticipationTaxAccountPlan': 'Plano de contas dos Juros da Antecipação',
      'anticipationIpiAccountPlan': 'Plano de contas do IOF da Antecipação',
      'anticipationCreditAccountPlan': 'Plano de contas do Crédito da Antecipação',
      'anticipationRepurchaseAccountPlan': 'Plano de contas da Recompra da Antecipação',
      'anticipationDebitAccountPlan': 'Plano de contas dos Débitos da Antecipação',
      'dynamicCompetenceDate': 'Habilitar competência dinâmica',
      'searchByCustomer': 'Buscar por cliente',
      'generateInvoiceReceipt': 'Habilitar recibo de serviço',
      'additionalInfo': 'Informações Complementares',
      'additionalInfoValue': 'Valor das Informações Complementares',
      'periodicalServicePriceFree': 'Preço livre',
      'messageAdditionalNavigationPlan': 'Mensagem adicional no plano de navegação',
      'editSlingInPreparation': 'Editar Lingada em Preparo',
      'financialMultipleCompaniesType': 'Tipo de faturamento múltiplas empresas',
      'washRunOption': 'Tipo de execução',
      'engineTurnRunOption': 'Tipo de execução',
      'printNavigationPlan': 'Imprimir plano de navegação',
      'printItemsDuringDelivery': 'Imprimir itens durante entrega',
      'automaticBlock': 'Bloqueio automático de inadimplente',
      'daysToBlock': 'Bloquear após (dias)',
      'discountDirect': 'Habilitar desconto direto na fatura',
      'typeBlockCustomer': 'Tipo de Bloqueio de Pendencias',
      'competency': 'Competência padrão para geração de notas fiscais',
      'cst': 'Situação Tributária do Cofins',
      'cofins': 'Situação Tributária do Cofins',
      'pis': 'Situação Tributária do Pis',
      'discountInInvoiceDoc': 'Habilitar desconto antes do vencimento a nota',
      'stockMovementSlingIn': 'Movimentação de estoque Lingada Entrada',
      'stockMovementSlingOut': 'Movimentação de estoque Lingada Saída',
      'stockMovementDetachedOut': 'Movimentação de estoque Avulsa Saída',
      'stockMovementDetachedIn': 'Movimentação de estoque Avulsa Entrada',
      'stockMovementAdjustmentIn': 'Movimentação de estoque Ajuste Entrada',
      'stockMovementAdjustmentOut': 'Movimentação de estoque Ajuste Saída',
      'franchiseProductId': 'Produto de franquia',
      'showAdvancedPayment': 'Exibir pagamento antecipado',
      'inviteControlYear': 'Ano de controle de convites',
      'dateRecharge': 'Data de recarga',
      'lastDateRecharge': 'Última data de recarga',
      'inviteQtd': 'Quantidade de convites',
      'inviteMaxBuy': 'Máximo de compra de convites',
      'inviteDailyLimit': 'Limite diário de convites',
      'inviteServiceId': 'ID do serviço de convite',
      'operationNature': 'Natureza da Operação',
      'interestInTaxnote': 'Habilitar adição de juros a Nota',
      'enableAutoEmailSending': 'Habilitar envio automático de e-mail',
      'checkReservation': 'Verificar reserva',
      'printNavigationPlanWeb': 'Imprimir plano de navegação Web',
      'printReceiptWeb': 'Imprimir recibo Web',
      'printItemsOnDeliveryWeb': 'Imprimir itens na entrega Web',
      'latitudePrevisao': 'Latitude Previsão',
      'longitudePrevisao': 'Longitude Previsão',
      'onlyOwnerInvoice': 'Faturas Somente Para proprietários',
      'usePersonalBillet': 'Boleto detalhado',
      'creditProductId': 'Produto de lançamento de crédito',
      'currency': 'Moeda de cobrança',
      'nbsCod': 'Código NBS Padrão',
      'negotiateProductId': 'Produto usado na negociação',
      'slingAppointmentTimes': 'Horários de agendamento',
      'slingOperationTimes': 'Horários de operação',
      'operationCloseDays': 'Dias fechados',
      'operationSpecialDays': 'Dias com horário especial',
      'frequentFestinations': 'Destinos frequentes',
      'users': 'Usuários'
    };

    const translationKey = fieldTranslations[fieldName];
    if (translationKey) {
      // Se a chave começa com maiúscula e tem hífen, é uma chave de tradução
      if (translationKey.match(/^[A-Z-]+$/)) {
        return this.translate.instant(translationKey);
      }
      // Caso contrário, retorna o texto direto
      return translationKey;
    }
    // Se não encontrar tradução, retorna o nome do campo formatado
    return fieldName;
  }
}
